import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CreateComponent } from "./create/create.component";
import { CratingComponent } from './crating/crating.component';
import { ListComponent } from "./list/list.component";
import { DetailsComponent } from "./details/details.component";
import { BatchstampService } from "./batchstamp.service";
import { ApiEvsService } from "app/common/services/ApiEvs.service";
import { BatchstampComponent } from "./batchstamp.component";
import {
    ConfirmationService,
    ConfirmDialogModule,
    GrowlModule,
} from "primeng/primeng";

import { TranslateModule } from '@ngx-translate/core';

import { routing } from "./batchstamp.routing";

import {
    FormsModule as AngularFormsModule,
    FormsModule,
    ReactiveFormsModule,
} from "@angular/forms";
import { ChartsModule } from "ng2-charts";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { CarouselModule, PopoverModule } from "ngx-bootstrap";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { CardModule } from "../../../../layout/card";
import { BlockModule } from "../../../../layout/block";
import { ModalModule } from "ngx-bootstrap/modal";
import { SelectModule } from "ng-select";
import { EvsStampService } from "../../../../common/services/EvsStamp.service";
import { BatchService } from "./batch.service";
import { PopupModule } from "../popup/popup.module";
import { ModalListBatchChildComponent } from "./list/modalListBatchChild.component";
import { QrCodeModule } from "./qr-code/qr-code.module";
import { MapComponent } from "../batchstamp/map/map.component";
import { ImportStampComponent } from "./import-stamp/import-stamp.component";
import { ImageService } from "../../../imageService";
import { FilterProductsModule } from "../../../../layout/filter-products/filter-products.module";
import { CratingStampsListComponent } from '../share/cratingStampsList/cratingStampsList.component';
import { BoxRetalStampsModule } from '../share/boxRetalStamps/boxRetalStamps.module';
import { BoxRetalStampsTHModule } from "../share/boxRetalStampsTH/boxRetalStampsTH.module";
import { HistoryBoxModule } from '../history-box/history-box.module';
import { HistoryActiveModule } from "./historyActive/historyActive.module";
import { ActiveTempNew } from '../share/ActiveTempNew/ActiveTempNew';
import { ImportCratingComponent } from '../import-crating/import-crating.component';
import { ImportCratingService } from "../import-crating/services/import-crating.services";
import { ImportCratingModule } from "../import-crating/import-crating.module";
import { DistributionInitModule } from '../distribution-init/distribution-init.module';
import { DistributionScanModule } from '../distribution-scan/distribution-scan.module';
import { UiComponentsModule } from "../../../../components/ui/ui.module";
import { WarrantyReminderModule } from '../../../../common/components/warranty-reminder/warranty-reminder.module';

@NgModule({
    imports: [
        CommonModule,
        routing,
        CarouselModule,
        PopoverModule.forRoot(),
        AngularFormsModule,
        ReactiveFormsModule,
        FormsModule,
        ChartsModule,
        TooltipModule.forRoot(),
        ConfirmDialogModule,
        GrowlModule,
        CardModule,
        BlockModule,
        ModalModule.forRoot(),
        BsDatepickerModule.forRoot(),
        SelectModule,
        PopupModule,
        QrCodeModule,
        FilterProductsModule,
        BoxRetalStampsModule,
        BoxRetalStampsTHModule,
        HistoryBoxModule,
        HistoryActiveModule,
        ImportCratingModule,
        DistributionInitModule,
        DistributionScanModule,
        UiComponentsModule,
        TranslateModule,
        WarrantyReminderModule
    ],
    declarations: [
        CreateComponent,
        CratingComponent,
        CratingStampsListComponent,
        ListComponent,
        BatchstampComponent,
        DetailsComponent,
        ModalListBatchChildComponent,
        MapComponent,
        ImportStampComponent,
        ActiveTempNew,
        ImportCratingComponent,
    ],
    providers: [
        ConfirmationService,
        BatchstampService,
        BatchService,
        ApiEvsService,
        EvsStampService,
        ImageService,
        ImportCratingService
    ],
    entryComponents: [ModalListBatchChildComponent],
    exports: [
        CreateComponent
    ]
})
export class BatchstampModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/batchstamp.module.ts